<template>
  <div>
    <v-dialog v-model="model" max-width="1000">
      <v-card class="pa-10">
        <div class="d-flex align-start mb-2">
          <div class="d-flex flex-column" style="flex:1;">
            <span style="font-size: 2rem"
                  class="font-rubik font-weight-medium">Correccions dels exàmens del {{ year }}</span>
            <span class="font-rubik">Les correccions són de la Generalitat de Catalunya i són provisionals, és a dir, poden contenir errades.</span>
          </div>
          <v-icon @click="model=false">{{ mdiClose() }}</v-icon>
        </div>

        <!-- Stepper Juny / Setembre -->
        <div v-if="availableMonths.length > 1" class="d-flex mb-4" style="gap: 8px;">
          <v-btn
            v-for="m in availableMonths"
            :key="m"
            depressed
            :color="selectedMonth === m ? '#256EFF' : 'grey lighten-3'"
            :dark="selectedMonth === m"
            class="text-none font-rubik"
            style="letter-spacing: unset; font-size: 1rem; border-radius: 10px;"
            @click="selectedMonth = m"
          >
            {{ m }}
          </v-btn>
        </div>
        <div v-else-if="availableMonths.length === 1" class="mb-4">
          <v-chip color="#256EFF" dark class="font-rubik" style="font-size: 0.95rem;">
            {{ availableMonths[0] }}
          </v-chip>
        </div>

        <!-- Llista d'assignatures -->
        <v-card v-for="subject in filteredSubjects"
                :key="subject.id"
                flat
                :class="$vuetify.breakpoint.smAndDown ? 'flex-column' : ''"
                class="d-flex align-center pa-3 mb-5 rounded-lg shadow-small mt-4 px-5"
        >
          <v-card
            :style="`background: linear-gradient(to bottom,rgba(255,255,255,0.2),rgba(0,0,0,0.05)),${getColor(subject)};`"
            style="border-radius: 14px"
            width="64" height="64" class="d-flex flex-column align-center justify-center shadow-small" flat>
            <v-icon
              class="icon-color"
              color="white"
              style="opacity: 0.9"
              size="30">
              {{ $vuetify.icons.values[subject.subject_icon] }}
            </v-icon>
          </v-card>
          <span class="font-rubik ml-4" style="font-size: 1.2rem; flex: 1">{{ subject.subject_name }}</span>

          <v-btn
            v-if="subject.added_en"
            @click="openPdf(subject, 'Enunciat')"
            depressed color="#CCF3FF"
            class="text-none"
            :class="$vuetify.breakpoint.smAndDown ? 'mt-3' : ''"
            style="letter-spacing: unset; font-size: 1rem; color: #256EFF"
          >
            Mostrar enunciat
          </v-btn>
          <v-btn
            v-if="subject.added_sol"
            @click="openPdf(subject, 'Solucio')"
            depressed color="grey lighten-2"
            aria-label="Mostrar solució"
            class="text-none"
            :class="$vuetify.breakpoint.smAndDown ? 'my-3 px-5' : 'ml-3'"
            style="letter-spacing: unset; font-size: 1rem"
          >
            Mostrar solució
          </v-btn>
        </v-card>

        <div v-if="filteredSubjects.length === 0" class="text-center py-8">
          <span class="font-rubik grey--text">Encara no hi ha exàmens de {{ selectedMonth }} disponibles.</span>
        </div>

      </v-card>
    </v-dialog>
  </div>
</template>

<script>

import {mdiClose} from "/src/assets/mdi.json";

export default {
  name: "NewExams",
  props: {
    value: Boolean
  },
  async mounted() {
    const {data} = await this.axios.get("/new-exams")
    this.subjects = data.filter(r => r.added_en || r.added_sol);

    // Seleccionar per defecte: Juny si disponible, sinó Setembre
    if (this.availableMonths.includes('Juny')) {
      this.selectedMonth = 'Juny';
    } else if (this.availableMonths.length > 0) {
      this.selectedMonth = this.availableMonths[0];
    }
  },
  data() {
    return {
      year: new Date().getFullYear(),
      model: false,
      subjects: [],
      selectedMonth: 'Juny',
      colors: [
        "#FF8FB1",
        "#256EFF",
        "#FFA201",
        "#2FCA9F",
        "#C47AFF",
        "#40C4FF",
        "#A460ED",
        "#8C9EFF",
        "#2F89FC",
        "#00BFA5",
        "#ffa63c",
      ]
    }
  },
  computed: {
    availableMonths() {
      const months = [...new Set(this.subjects.map(s => s.exam_month))];
      // Ordenar: Juny primer, Setembre segon
      return ['Juny', 'Setembre'].filter(m => months.includes(m));
    },
    filteredSubjects() {
      return this.subjects.filter(s => s.exam_month === this.selectedMonth);
    }
  },
  methods: {
    mdiClose() {
      return mdiClose
    },
    getColor(subject) {
      return this.colors[subject.subject_id % this.colors.length]
    },
    async openPdf(subject, type) {
      const month = subject.exam_month;

      if (this.$vuetify.breakpoint.smAndDown) {
        const pdf = `https://examenselectivitat.cat:3000/api/pdfs/${subject.subject_path}/${this.year}/${month}/${type}`;
        window.open(pdf);
      } else {
        this.$router.push({path: '/selectivitat/' + subject.subject_name + `/pdf/${this.year}/${month}/` + type})
      }
    },
  },
  watch: {
    value(val) {
      this.model = val;
    },
    model(val) {
      this.$emit('update:value', val);
    },
    availableMonths(months) {
      if (!months.includes(this.selectedMonth) && months.length > 0) {
        this.selectedMonth = months[0];
      }
    }
  }
}
</script>

<style scoped>

</style>
